import { compose } from 'redux';
import { connect } from 'react-redux';
import subscriptionDecorator from 'subscriptions/decorator';
import * as routes from 'app/routes';

import {
  getCurrentSprintPlan,
  getUpcomingSprintPlan,
  getCurrentUsage,
  getAllSprintPlans,
  getOverduePurchases,
  getUser,
} from 'reducers';

import {
  fetchAll as fetchAllPlans,
  findUpcoming as findUpcomingPlan
} from 'subscriptions/plans/sprint/actions';

import { fetchFiltered as fetchFilteredPurchases } from 'billing/purchases/actions';

import { findCurrent as findCurrentUsage } from 'subscriptions/usage/sprint/actions';
import { createSprintUpgrade as createUpgradePurchase } from 'billing/purchases/actions';
import AddDataPicker from './AddDataPicker';


const mapStateToProps = (state, { subId }) => ({
  upcomingPlan: getUpcomingSprintPlan(state, subId),
  currentPlan: getCurrentSprintPlan(state, subId),
  allPlans: getAllSprintPlans(state),
  usage: getCurrentUsage(state, subId),
  overduePurchases: getOverduePurchases(state),
  user: getUser(state),
});

const mapDispatchToProps = {
  fetchAllPlans,
  findUpcomingPlan,
  findCurrentUsage,
  createUpgradePurchase,
  purchaseRoute: routes.sprintAddDataPurchase,
  fetchFilteredPurchases,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AddDataPicker);
